import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { External } from '../../Link';
import { makeStyles } from '@material-ui/core/styles';

export const Headline = props => <Typography variant="caption"  color="textSecondary" component="h4" {...props} />
export const Paragraph = props => <Typography variant="caption" component="p" gutterBottom  {...props} />
